module.exports = __webpack_public_path__ + "static/media/inc-bot.b71fe532.svg";